export const greetingTitleStyles = theme => ({
  fontFamily: '"Source Serif Pro", serif',
  fontWeight: 700,
  fontSize: '40px',
  lineHeight: 1.2,
  color: '#00234B',
  textTransform: 'none',
  maxWidth: '100%',
  overflowWrap: 'break-word',
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
  },
})
